import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=a43fdf7c&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a43fdf7c')) {
      api.createRecord('a43fdf7c', component.options)
    } else {
      api.reload('a43fdf7c', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=a43fdf7c&", function () {
      api.rerender('a43fdf7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/DmVisualizer/Components/Index.vue"
export default component.exports